import { loadGSAP } from '../../externals/gsap.js';
import { playOnScroll } from '../../utils/scroll-play.js';

export const defaults = {
  from: 0,
  duration: 2,
  ease: 'power2.out',
  prefix: '',
  suffix: '',
  decimals: 0,
};

export default async function counter(el, options) {
  await loadGSAP();
  const { gsap } = window;

  const to       = parseFloat(el.textContent.replace(/[^0-9.-]/g, '')) || 0;
  const from     = parseFloat(options.from);
  const duration = parseFloat(options.duration);
  const decimals = parseInt(options.decimals, 10);
  const { ease, prefix, suffix } = options;

  const obj = { value: from };
  const render = () => { el.textContent = prefix + obj.value.toFixed(decimals) + suffix; };
  render();

  const tween = gsap.to(obj, {
    value: to,
    duration,
    ease,
    paused: true,
    onUpdate: render,
  });
  playOnScroll(el, tween, options);
}
